import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { filter } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private storageKey = 'navHistory';
  private limit = 5;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.pushToHistory(event.urlAfterRedirects || event.url);
      });
  }

  private getHistory(): string[] {
    if (!isPlatformBrowser(this.platformId)) {
      return [];
    }
    if (typeof sessionStorage === 'undefined') {
      return [];
    }

    const raw = sessionStorage.getItem(this.storageKey);
    return raw ? JSON.parse(raw) : [];
  }

  private setHistory(history: string[]): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    if (typeof sessionStorage === 'undefined') {
      return;
    }

    sessionStorage.setItem(this.storageKey, JSON.stringify(history));
  }

  private pushToHistory(url: string): void {
    let history = this.getHistory();
    const last = history[history.length - 1];

    if (last !== url) {
      history.push(url);
      if (history.length > this.limit) {
        history = history.slice(history.length - this.limit);
      }
      this.setHistory(history);
    }
  }

  public getPreviousUrl(isPreviousPrevious: boolean = false): string | null {
    const history = this.getHistory();
    return history.length > 1
      ? history[history.length - (isPreviousPrevious ? 3 : 2)]
      : null;
  }

  public goBack(isPreviousPrevious: boolean = false): void {
    const prev = this.getPreviousUrl(isPreviousPrevious);
    const rutasNoPermitidas = [
      '/login',
      '/register',
      '/forgot-password',
      '/reset-password',
      '/garage/agregar-vehiculo',
      '/garage',
    ];

    if (rutasNoPermitidas.includes(prev || '')) {
      this.router.navigate(['/']);
      return;
    }

    if (prev) {
      this.router.navigate([prev]);
    } else if (isPlatformBrowser(this.platformId)) {
      // Si no hay historial, usar el historial del navegador
      window.history.back();
    }
  }

  public clearHistory(): void {
    this.setHistory([]);
  }
}
